webpackJsonp([172411548396689],{

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _page = __webpack_require__(5);
	
	var _page2 = _interopRequireDefault(_page);
	
	__webpack_require__(424);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImpressumPage = function ImpressumPage(props) {
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(_page2.default, { headline: 'Impressum' }),
	    _react2.default.createElement(
	      'div',
	      { id: 'impressum', className: 'container-custom' },
	      _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'F\xFCr den Inhalt verantwortlich gem\xE4\xDF ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            '\xA7 10 Absatz 3 MDStV'
	          ),
	          ':',
	          _react2.default.createElement('br', null)
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Magnet Resonanz Institut Bregenz GmbH'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Dr. Herbert Vonbank, Dr. Matthias Dietlein, Dr. Peter Mittelberger'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'UID Nr.: ATU57326003'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Firmenbuchnummer: FN237376'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Zust\xE4ndiges Gericht: Landesgericht Feldkirch als Firmenbuchgericht, Schillerstra\xDFe 1, 6800'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          'address',
	          null,
	          'R\xF6merstra\xDFe 9-13 ',
	          _react2.default.createElement('br', null),
	          '6900 Bregenz ',
	          _react2.default.createElement('br', null),
	          'Telefon: ',
	          _react2.default.createElement(
	            'a',
	            { href: 'tel: 0043557453500' },
	            '+43 5574 53500'
	          ),
	          _react2.default.createElement('br', null),
	          'E-Mail: ',
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:office@radbregenz.at' },
	            'office@radbregenz.at'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'a',
	            { href: 'www.radbregenz.at' },
	            'www.radbregenz.at'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Mitglied der Wirtschaftskammer Vorarlberg'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://firmen.wko.at/Web/DetailsKontakt.aspx?FirmaID=80c8a525-89ac-4211-adc7-a8e25d9d2d94&StandortID=132' },
	              'Gewerbeordnung'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Bezirkshauptmannschaft: BH Bregenz'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          'a',
	          { target: '_blank', href: '/Anstaltsordnung.pdf' },
	          'Anstaltsordnung'
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'Design & Programmierung: ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://zeughaus.com' },
	            'Zeughaus Design GmbH'
	          ),
	          ', Neustadt 11, 6800 Feldkirch'
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'Haftungshinweis: Trotz sorgf\xE4ltiger inhaltlicher Kontrolle \xFCbernehmen wir keine Haftung f\xFCr die Inhalte externer Links. F\xFCr den Inhalt der verlinkten Seiten sind ausschlie\xDFlich deren Betreiber verantwortlich.'
	        )
	      )
	    )
	  );
	};
	
	exports.default = ImpressumPage;
	module.exports = exports['default'];

/***/ }),

/***/ 424:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-impressum-js-8c3e6228331619101181.js